import React, { memo } from "react";
import { useSelector } from "react-redux";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import LocalFireDepartmentOutlinedIcon from "@mui/icons-material/LocalFireDepartmentOutlined";
import DoNotTouchOutlinedIcon from "@mui/icons-material/DoNotTouchOutlined";
import { ENTITY_TYPES } from "../../../utils";
import { Grid } from "@mui/material";

const CustomListContainerStyle = {
  marginTop: "10px",
  paddingBottom: "5px",
};

const LegendSx = {
  fontSize: "13px",
  marginRight: "10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

const LegendColorSx = (color) => ({
  display: "inline-block",
  backgroundColor: color,
  width: "12px",
  height: "12px",
  borderRadius: "2px",
  marginRight: "3px",
});

const SelectAllSx = (hide) => ({
  visibility: hide ? "hidden" : "visible",
  paddingTop: "12px",

  "& .MuiTypography-root": {
    fontSize: "13px",
  },
  "& .MuiCheckbox-root": {
    paddingRight: "4px",
  },
});

const HazmatRestrictedLegendSx = {
  fontSize: "18px",
  color: "#ff5722",
  marginRight: "5px",
};

function StoreSuppliesListContainer({
  children,
  entityType = "",
  handleSelectAll,
  resultLoading = true,
  isResultPresent = false,
  disableSelectAll = false,
  selectAll = false,
  hideSelectAll = false,
  exportButton = <></>,
  stickyHeader = <></>,
  resetAction = <></>,
}) {
  const adjQtyError = useSelector((store) => store.global.adjQtyError);
  const isFillInOrder = useSelector(
    (store) => store.global.store.isFillInOrder
  );

  return (
    <div style={CustomListContainerStyle}>
      <>
        {!resultLoading && isResultPresent && (
          <FormControlLabel
            sx={SelectAllSx(hideSelectAll || disableSelectAll)}
            control={
              <Checkbox
                size="small"
                disableRipple
                checked={selectAll}
                disabled={disableSelectAll || adjQtyError}
                onClick={handleSelectAll}
                sx={{
                  padding: "0px",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                }}
              />
            }
            label="Select All"
          />
        )}
        {isResultPresent && (
          <div
            style={{
              float: "right",
              paddingTop: "5px",
              display: "flex",
            }}
          >
            {entityType === ENTITY_TYPES.ssPlanogram && (
              <div style={LegendSx}>
                <DoNotTouchOutlinedIcon sx={HazmatRestrictedLegendSx} />{" "}
                Restricted
              </div>
            )}
            <div style={LegendSx}>
              <span style={LegendColorSx("blue")}></span> Selected
            </div>
            {entityType === ENTITY_TYPES.ssItem && (
              <div style={LegendSx}>
                <span style={LegendColorSx("orange")}></span> Restricted
              </div>
            )}
            {entityType === ENTITY_TYPES.ssPlanogram && (
              <>
                <div style={LegendSx}>
                  <span style={LegendColorSx("black")}></span> Duplicate
                </div>
                <div style={LegendSx}>
                  <span style={LegendColorSx("green")}></span> Released
                </div>
              </>
            )}
            {entityType === ENTITY_TYPES.ssItem && (
              <div style={LegendSx}>
                <span style={LegendColorSx("green")}></span> Released
              </div>
            )}
            {exportButton}
          </div>
        )}
      </>
      {!resultLoading && isResultPresent && stickyHeader}
      <div>{children}</div>
      {!resultLoading && isResultPresent && !disableSelectAll && (
        <Grid
          container
          flex
          justifyContent="space-between"
          spacing={1}
          alignItems="center"
          pt={1}
        >
          <Grid item>
            <Grid item>{resetAction}</Grid>
          </Grid>
        </Grid>
      )}
    </div>
  );
}

export default memo(StoreSuppliesListContainer);
